export const WHITEBOARD_COLORS: any = {
  color_001f3f: '#001f3f',
	color_FF4136: '#FF4136',
	color_0074D9: '#0074D9',
	color_FF851B: '#FF851B',
	color_FFDC00: '#FFDC00',
	color_3D9970: '#3D9970',
	color_91E99B: '#91E99B',
	color_90468b: '#90468b',
	color_7FDBFF: '#7FDBFF',
	color_AAAAAA: '#AAAAAA',
	color_E65194: '#E65194',
	chooseColor: '#FFFFFF'
};

export const DEFAULT_COLOR: any = {
	DRAFT: 'color_001f3f',
	DRAFT_TEACHER: 'color_3D9970',
	FEEDBACK: 'color_FF4136'
};

export type ToolIconType = {
  [key: string]: {
    icon: string;
    i18n: string;
    refId?: string;
    id?: string;
    name?: string;
    oneTouch?: boolean;
    isDisabled?: boolean;
    isMultiple?: boolean;
    multiple?: { icon: string };
    options?: any;
  };
};

export function toolIcons(): ToolIconType {
  return {
    undo: {
      icon: 'undo',
      refId: 'toolID-Undo',
      id: 'toolID-Undo-Id',
      i18n: 'drawItems.undo',
      name: 'Undo',
      oneTouch: true,
      isDisabled: true
    },
    redo: {
      icon: 'redo',
      refId: 'toolID-Redo',
      id: 'toolID-Redo-Id',
      i18n: 'drawItems.redo',
      name: 'Redo',
      oneTouch: true,
      isDisabled: true
    },
    pencil: {
      icon: 'pencil-alt',
      refId: 'toolID-Pencil',
      id: 'toolID-Pencil-Id',
      i18n: 'drawItems.pencil',
      name: 'Pencil'
    },
    line: {
      icon: 'tool-line',
      refId: 'toolID-Straight line',
      id: 'toolID-Straight-line-Id',
      i18n: 'drawItems.straightLine',
      name: 'Straight line'
    },
    /* Options commented because those are not support mobile
            shapes: {icon: 'rectangle', i18n: 'drawItems.shapes', isMultiple: true , multiple: {icon: 'caret-down'},
        options: {
          rectangle: {icon: 'rectangle', refId: 'toolID-Rectangle', i18n: 'drawItems.rectangle' , name: 'Rectangle'},
          square: {icon: 'square', refId: 'toolID-Rectangle',i18n: 'drawItems.square' , name: 'Square'},
          ellipse: {icon: 'ellipse-outline', refId: 'toolID-Ellipse', i18n: 'drawItems.ellipse', name: 'Ellipse'},
          circle: {icon: 'circle-solid', refId: 'toolID-Ellipse',i18n: 'drawItems.circle', name: 'Circle'}
        }},
            font: {icon: 'font', refId: 'toolID-Text', id: 'toolID-Text-Id', i18n: 'drawItems.text', name: 'Text'}, */
    move: {
      icon: 'hand-paper',
      i18n: 'common.move',
      isMultiple: true,
      multiple: { icon: 'caret-down' },
      options: {
        hand: {
          icon: 'hand-paper',
          refId: 'toolID-Hand',
          id: 'toolID-Hand-Id',
          i18n: 'drawItems.hand',
          name: 'Hand',
          condition: 'isShowHand',
          conditionValue: true
        },
        mover: {
          icon: 'arrows-alt-solid',
          refId: 'toolID-Hand',
          id: 'toolID-Mover-Id',
          i18n: 'common.move',
          name: 'Hand',
          isSecondary: true
        }
      }
    },
    delete: {
      icon: 'eraser',
      i18n: 'common.remove',
      isMultiple: true,
      multiple: { icon: 'caret-down' },
      options: {
        eraser: {
          icon: 'eraser',
          refId: 'toolID-Eraser',
          id: 'toolID-Eraser-Id',
          i18n: 'drawItems.eraser',
          name: 'Eraser'
        },
        tape: {
          icon: 'tape',
          refId: 'toolID-Pencil',
          id: 'toolID-white-out-Id',
          i18n: 'drawItems.whiteout',
          name: 'Pencil',
          isSecondary: true
        },
        trash: {
          icon: 'trash',
          refId: 'toolID-Eraser All',
          id: 'toolID-Eraser-All-Id',
          i18n: 'drawItems.removeAll',
          name: 'Eraser All'
        },
        currentPage: {
          icon: 'file-delete',
          refId: 'toolID-Eraser Range',
          id: 'toolID-Eraser-Range-Id',
          i18n: 'drawItems.removeCurrent',
          name: 'Eraser All',
          originalRefId: 'toolID-Eraser All',
          condition: 'isPageBasedType',
          conditionValue: true
        }
      }
    }
    /* Option commented because this is not support mobile
            zoom: {icon: 'search-solid', refId: 'toolID-Zoom', i18n: 'drawItems.zoom' , name: 'Zoom'}
            */
  };
}

export type ToolRangeType = {
  [key: string]: {
    icon: string;
    refId: string;
    i18n: string;
    isShow: boolean;
    value: number;
    min: number;
    max: number;
    step: number;
  };
};

export function toolRanges(): ToolRangeType {
  return {
    chooseSize: {
      icon: 'cb-size',
      refId: 'chooseSize',
      i18n: 'drawItems.size',
      isShow: false,
      value: 1,
      min: 1,
      max: 50,
      step: 1
    },
    chooseOpacity: {
      icon: 'braille',
      refId: 'chooseOpacity',
      i18n: 'drawItems.opacity',
      isShow: false,
      value: 1,
      min: 0.2,
      max: 1,
      step: 0.1
    }
  };
}

export const UNDER_LINE : string = '_';

export const COLOR_PICKER_ID = 'chooseColor';

export const IFRAME_CONTENT = 'contentWindow';

export const BOARD_EVENTS : any = {
	CHANGE_TOOGLE_TOOL: 'CHANGE_TOOGLE_TOOL',
    CHANGE_BOARD_COLOR: 'CHANGE_BOARD_COLOR',
    CHANGE_TOOL_SIZE: 'CHANGE_TOOL_SIZE',
    CHANGE_TOOL_OPACITY: 'CHANGE_TOOL_OPACITY',
    ADD_CLASS_CURRENT_PAGE_: 'ADD_CLASS_CURRENT_PAGE_',
    REMOVE_CLASS_CURRENT_PAGE: 'REMOVE_CLASS_CURRENT_PAGE_',
	DRAWING_TASK: 'DRAWING_TASK',
	BOARD_WORK_IN_PROGRESS: 'BOARD_WORK_IN_PROGRESS',
	CLOSE_LOADING_BOARD_TASK: 'CLOSE_LOADING_BOARD_TASK',
	RECONNECT_BOARD: 'RECONNECT_BOARD',
	INIT_BOARD_TASK: 'INIT_BOARD_TASK',
	LOADED_PDF_PAGE: 'LOADED_PDF_PAGE_',
	CREATE_BOARD_PAGE: 'CREATE_BOARD_PAGE_',
	JOINED: 'JOINED',
	REMOVE_ELEMENTS: '_REMOVE_ELEMENTS',
	BOARD_ANNOTATIONS_UPDATED: 'BOARD_ANNOTATIONS_UPDATED',
  STUDENT_INITIAL_BOARDS_LOADED: 'STUDENT_INITIAL_BOARDS_LOADED',
  UPDATE_LAYOUT: 'UPDATE_LAYOUT',
	CREATE_BOARD: '_CREATE_BOARD',
	RESIZE_BOARD: 'RESIZE_BOARD',
	CURSOR_UPDATED: 'CURSOR_UPDATED',
	USER_DISCONNECTED: 'USER_DISCONNECTED',
    BOARD_READY: 'BOARD_READY',
    BOARD_ACTIVATED: 'BOARD_ACTIVATED',
    ENABLE_BOARD_TOOLS: 'ENABLE_BOARD_TOOLS',
    ADD_EXTRA_PAGES: 'ADD_EXTRA_PAGES',
    PAGE_CONTAINER_CLICKED: 'PAGE_CONTAINER_CLICKED',
    HISTORY_READY: 'HISTORY_READY',
    REFRESH_BOARD: 'REFRESH_BOARD',
};

export const HOMEWORK_TEMPLATE_DEFAULT_NAME = 'blank';

export const HOMEWORK_TEMPLATE_NAMES : any = {
	RESPONSE_PAPER: 'RESPONSE_PAPER',
	BLANK: 'BLANK'
};

export const BOARD_ANNOTATION_OPTIONS = {
	undo: 'undoBoardAnnotations',
	redo: 'redoBoardAnnotations'
};

export const BOARD_CONFIG_PARAMETERS = {
	BLOCKED_TOOLS: 'wboBlockedTools',
	MAX_BOARD_SIZE: 'wboMaxBoardSize',
	MAX_EMIT_COUNT_PERIOD: 'wboMaxEmitCountPeriod',
	MAX_EMIT_COUNT: 'wboMaxEmitCount',
	MAX_PENCIL_POINTS: 'wboMaxPencilPoints',
	MAX_UNDO_ACTIONS: 50
};

export const BLANK_PIXEL_IMG = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdj+P///38ACfsD/QVDRcoAAAAASUVORK5CYII=';
